import AssetTwo from './AssetTwo';

export default AssetTwo;
